export type RbimCodeQuestionKey = keyof typeof RBIM_CODE_MAP;

export type RbimCodeCleanResult = {
  code: string;
  label: string | null;
  error?: string;
};

export type RbimCodeOption = {
  code: string;
  label: string;
  displayValue: string;
};

type RbimCodeMeta = {
  label: string;
  allowUnmapped?: boolean;
};

export const RBIM_CODE_MAP = {
  q02_relationship_to_head: {
    "01": "Head",
    "02": "Spouse",
    "03": "Son",
    "04": "Daughter",
    "05": "Stepson",
    "06": "Stepdaughter",
    "07": "Son-in-law",
    "08": "Daughter-in-law",
    "09": "Grandson",
    "10": "Granddaughter",
    "11": "Father",
    "12": "Mother",
    "13": "Brother",
    "14": "Sister",
    "15": "Uncle",
    "16": "Aunt",
    "17": "Nephew",
    "18": "Niece",
    "19": "Other relative",
    "20": "Non-relative",
    "21": "Boarder",
    "22": "Domestic helper",
  },
  q03_sex: {
    "1": "Male",
    "2": "Female",
  },
  q07_nationality: {
    "1": "Filipino",
    "2": "Non-Filipino",
  },
  q08_marital_status: {
    "1": "Single",
    "2": "Married",
    "3": "Common-law / Live-in",
    "4": "Widowed",
    "5": "Separated",
    "6": "Divorced / Annulled",
    "7": "Unknown",
  },
  q11_highest_education: {
    "0": "Early Childhood Education",
    "1": "Primary Education",
    "2": "Lower Secondary Education",
    "3": "Upper Secondary Education",
    "4": "Post-Secondary Non-Tertiary Education",
    "5": "Short-Cycle Tertiary Education",
    "6": "Bachelor Level Education or Equivalent",
    "7": "Master Level Education or Equivalent",
    "8": "Doctoral Level Education or Equivalent",
    "99": "N/A",
  },
  q12_currently_enrolled: {
    "1": "Yes, public",
    "2": "Yes, private",
    "3": "No",
    "99": "99 - N/A",
  },
  q13_school_level: {
    "0": "Early Childhood Education",
    "1": "Primary Education",
    "2": "Lower Secondary Education",
    "3": "Upper Secondary Education",
    "4": "Post-Secondary Non-Tertiary Education",
    "5": "Short-Cycle Tertiary Education",
    "6": "Bachelor Level Education or Equivalent",
    "7": "Master Level Education or Equivalent",
    "8": "Doctoral Level Education or Equivalent",
    "99": "N/A",
  },
  q14_place_of_school: {
    "99": "99 - N/A",
  },
  q15_reason_not_attending_school: {
    "1": "Financial constraints / lack of school expenses",
    "2": "Working or seeking employment",
    "3": "Household responsibilities / caring for siblings or family",
    "4": "Early pregnancy / parenthood",
    "5": "Early marriage / live-in arrangement",
    "6": "Lack of interest in schooling",
    "7": "Illness or health condition",
    "8": "Disability / special needs",
    "9": "Bullying / discrimination",
    "10": "Distance of school / no transportation",
    "11": "No available school nearby",
    "12": "Conflict / disaster displacement",
    "13": "Failed or repeated grade(s)",
    "14": "Waiting for enrollment / transfer",
    "15": "Pandemic-related reasons",
    "16": "Family problem",
    "17": "Security / safety concerns",
    "18": "Finished desired level of education",
    "19": "Lack of documents / requirements",
    "20": "Others",
    "99": "99 - N/A",
  },
  q17_source_of_income: {
    "1": "Employment",
    "2": "Business",
    "3": "Remittance",
    "4": "Investments",
    "5": "Others",
    "99": "99 - N/A",
  },
  q18_work_status: {
    "1": "Permanent Work",
    "2": "Casual Work",
    "3": "Contractual Work",
    "4": "Individually Owned Business",
    "5": "Shared / Partnership Business",
    "6": "Corporate Business",
    "99": "99 - N/A",
  },
  q19_place_of_work: {
    "99": "99 - N/A",
  },
  q20_place_of_delivery: {
    "1": "Public Hospital",
    "2": "Private Hospital",
    "3": "Lying-in Clinic",
    "4": "Home",
    "5": "Others",
    "99": "99 - N/A",
  },
  q21_birth_attendant: {
    "1": "Doctor",
    "2": "Nurse",
    "3": "Midwife",
    "4": "Hilot",
    "5": "Others",
    "99": "99 - N/A",
  },
  q22_immunization: {
    "1": "BCG",
    "2": "Hep B",
    "3": "DTP",
    "4": "IPV",
    "5": "OPV/IPV",
    "6": "PCV",
    "7": "RV",
    "8": "Influenza",
    "9": "Measles",
    "10": "JEV",
    "99": "99 - N/A",
  },
  q24_family_planning_use: {
    "0": "None",
    "1": "Female sterilization / ligation",
    "2": "Male sterilization / vasectomy",
    "3": "IUD",
    "4": "Injectables",
    "5": "Implants",
    "6": "Pill",
    "7": "Condom",
    "8": "Modern natural FP",
    "9": "Lactational Amenorrhea Method (LAM)",
    "99": "99 - N/A",
  },
  q25_fp_method_source: {
    "1": "Government hospital",
    "2": "RHU / Health Center",
    "3": "Barangay Health Station",
    "4": "Private hospital",
    "5": "Pharmacy",
    "6": "Others",
    "99": "99 - N/A",
  },
  q26_intention_to_use_fp: {
    "1": "Yes",
    "2": "No",
    "99": "99 - N/A",
  },
  q26_intended_fp_method: {
    "0": "None",
    "1": "Female sterilization / ligation",
    "2": "Male sterilization / vasectomy",
    "3": "IUD",
    "4": "Injectables",
    "5": "Implants",
    "6": "Pill",
    "7": "Condom",
    "8": "Modern natural FP",
    "9": "Lactational Amenorrhea Method (LAM)",
    "10": "Traditional",
    "99": "99 - N/A",
  },
  q27_health_insurance: {
    "0": "None",
    "1": "PhilHealth paying member",
    "2": "PhilHealth dependent of paying member",
    "3": "PhilHealth indigent member",
    "4": "PhilHealth dependent of indigent member",
    "5": "GSIS",
    "6": "SSS",
    "7": "Private / HMO",
    "8": "Others",
    "99": "99 - N/A",
  },
  q28_facility_visited: {
    "0": "None",
    "1": "Government hospital",
    "2": "Rural Health Unit / Health Center",
    "3": "Barangay Health Station",
    "4": "Private Hospital",
    "5": "Private Clinic",
    "6": "Pharmacy",
    "7": "Hilot / Herbalist",
    "8": "Others",
    "99": "99 - N/A",
  },
  q29_health_facility_visit_reason: {
    "0": "None",
    "1": "Sick / Injured",
    "2": "Prenatal / Postnatal",
    "3": "Gave birth",
    "4": "Dental",
    "5": "Medical check-up",
    "6": "Medical requirement",
    "7": "NHTS / CCT / 4Ps requirement",
    "8": "Others",
    "99": "99 - N/A",
  },
  q30_disability: {
    "0": "None",
    "1": "Psychosocial Disability",
    "2": "Chronic Illness",
    "3": "Learning Disability",
    "4": "Mental Disability",
    "5": "Visual Disability",
    "6": "Orthopedic Disability",
    "7": "Hearing Disability",
    "8": "Speech Impairment",
    "9": "Multiple Disability",
    "99": "99 - N/A",
  },
  q31_solo_parent: {
    "1": "Registered Solo Parent",
    "2": "Non-Solo Parent",
    "3": "Unregistered Solo Parent",
    "99": "N/A",
  },
  q32_registered_senior_citizen: {
    "1": "Yes",
    "2": "No",
    "99": "99 - N/A",
  },
  q34_length_of_stay_barangay: {
    "99": "99 - N/A",
  },
  q35_previous_residence_five_years: {
    "99": "99 - N/A",
  },
  q36_previous_residence_six_months: {
    "99": "99 - N/A",
  },
  q37_resident_type: {
    "1": "Non-Migrant",
    "2": "Migrant",
    "3": "Transient",
    "99": "99 - N/A",
  },
  q38_date_of_transfer: {
    "99": "99 - N/A",
  },
  q39_reason_leaving_previous_residence: {
    "01": "Lack of employment",
    "02": "Perception of better income in other place",
    "03": "Schooling",
    "04": "Presence of relatives and friends in other place",
    "05": "Employment / Job relocation",
    "06": "Disaster-related relocation",
    "07": "Retirement",
    "08": "To live with parents",
    "09": "To live with children",
    "10": "Marriage",
    "11": "Annulment / Divorce / Separation",
    "12": "Commuting-related reasons",
    "13": "Health-related reasons",
    "14": "Peace and security",
    "15": "Others",
    "99": "99 - N/A",
  },
  q40_return_to_previous_residence: {
    "1": "Yes",
    "2": "No",
    "99": "99 - N/A",
  },
  q41_reason_transferring_barangay: {
    "1": "Availability of jobs",
    "2": "Higher wage",
    "3": "Presence of schools or universities",
    "4": "Presence of relatives and friends in other place",
    "5": "Others",
    "99": "99 - N/A",
  },
  q42_duration_of_stay_current_barangay: {
    "1": "Yes",
    "2": "No",
    "99": "99 - N/A",
  },
  q43a_has_valid_ctc: {
    "1": "Yes",
    "2": "No",
    "99": "N/A",
  },
  q43b_ctc_issued_in_barangay: {
    "1": "Yes",
    "2": "No",
    "99": "N/A",
  },
  q44_skills_development_training: {
    "0": "None",
    "99": "99 - N/A",
  },
  q45_skills: {
    "0": "None",
    "01": "Refrigeration and Airconditioning",
    "02": "Automotive / Heavy Equipment Servicing",
    "03": "Metal Worker",
    "04": "Building Wiring Installation",
    "05": "Heavy Equipment Operation",
    "06": "Plumbing",
    "07": "Welding",
    "08": "Carpentry",
    "09": "Baking",
    "10": "Dressmaking",
    "11": "Linguist",
    "12": "Computer Graphics",
    "13": "Painting",
    "14": "Beauty Care",
    "15": "Commercial Cooking",
    "16": "Housekeeping",
    "17": "Massage Therapy",
    "18": "Others",
    "99": "99 - N/A",
  },
  q46_housing_unit_tenure: {
    "1": "Rent-free without consent of owner",
    "2": "Rent-free with consent of owner",
    "3": "Rented",
    "4": "Owned / being amortized",
  },
  q47_lot_tenure: {
    "1": "Rent-free without consent of owner",
    "2": "Rent-free with consent of owner",
    "3": "Rented",
    "4": "Owned / being amortized",
  },
  q48_hazard_prone_area: {
    "1": "Flood-prone area",
    "2": "Landslide-prone area",
    "3": "Coastal / storm surge area",
    "4": "River bank area",
    "5": "Fire prone area",
    "6": "Others, please specify",
  },
  q49_disaster_experienced_past_5_years: {
    "1": "Flood",
    "2": "Typhoon",
    "3": "Landslide",
    "4": "Earthquake",
    "5": "Fire",
    "6": "Drought",
    "7": "Others, please specify",
  },
  q50_knows_nearest_evacuation_center: {
    "1": "Yes",
    "2": "No",
  },
  q51_fuel_lighting: {
    "0": "None",
    "1": "Oil",
    "2": "Liquefied petroleum gas",
    "3": "Kerosene",
    "4": "Electricity",
    "5": "Others, please specify",
  },
  q52_fuel_cooking: {
    "0": "None",
    "1": "Wood",
    "2": "Charcoal",
    "3": "Liquefied petroleum gas",
    "4": "Kerosene",
    "5": "Electricity",
    "6": "Others, please specify",
  },
  q53_drinking_water_source: {
    "1": "Piped into dwelling",
    "2": "Piped to yard / lot",
    "3": "Piped to neighbor",
    "4": "Public tap / standpipe",
    "5": "Tube well or borehole",
    "6": "Protected well",
    "7": "Unprotected well",
    "8": "Protected spring",
    "9": "Unprotected spring",
    "10": "Rainwater",
    "11": "Tanker truck",
    "12": "Cart with small tank",
    "13": "Surface water",
    "14": "Bottled water",
    "15": "Sachet water",
    "16": "Water refilling station",
    "17": "Others, please specify",
  },
  q54a_kitchen_garbage_disposal: {
    "1": "Feeding to animals",
    "2": "Burying",
    "3": "Composting",
    "4": "Burning",
    "5": "Dumping individual pit",
    "6": "Picked-up by garbage truck",
  },
  q54b_garbage_segregation: {
    "1": "Yes",
    "2": "No",
  },
  q55_toilet_facility_final: {
    "1": "Flush or pour flush toilet",
    "1A": "Flush to piped sewer system",
    "1B": "Flush to septic tank",
    "1C": "Flush to pit latrine",
    "1D": "Flush to open drain",
    "1E": "Flush to don't know where",
    "2": "Pit latrine",
    "2A": "Ventilated improved latrine",
    "2B": "Pit latrine with slab",
    "2C": "Pit latrine without slab / open pit",
    "3": "Hanging toilet / hanging latrine",
    "4": "Composting toilet",
    "5": "Bucket / Pail system",
    "6": "No facility / bush / field",
    "7": "Public toilet",
    "8": "Others, please specify",
  },
  q56_building_type: {
    "1": "Single house",
    "2": "Duplex",
    "3": "Apartment / Rowhouse",
    "4": "Condominium / Condotel",
    "5": "Other multi-unit residential building",
    "6": "Commercial / Industrial / Agricultural",
    "7": "Institutional living quarter",
    "8": "Other housing units",
  },
  q57_wall_material: {
    "1": "Concrete / brick / stone",
    "2": "Wood",
    "3": "Half concrete / brick / stone and half wood",
    "4": "Galvanized iron / aluminum",
    "5": "Bamboo / sawali / cogon / nipa",
    "6": "Asbestos",
    "7": "Glass",
    "8": "Makeshift / salvaged / improvised materials",
    "9": "Others, please specify",
    "10": "No walls",
  },
  q58_female_death_past_12_months: {
    "1": "Yes",
    "2": "No",
  },
  q59_child_death_past_12_months: {
    "1": "Yes",
    "2": "No",
  },
  q59_child_death_sex: {
    "1": "Male",
    "2": "Female",
    "99": "99 - N/A",
  },
  // Legacy questionnaire keys are retained only for historical import/code
  // normalization. The active Q34-Q36 keys are the official mappings above.
  q16_source_of_income: {
    "1": "EMPLOYMENT",
    "2": "BUSINESS",
    "3": "REMITTANCE",
    "4": "INVESTMENTS",
    "5": "OTHERS",
    "99": "N/A",
  },
  q17_work_status: {
    "1": "PERMANENT WORK",
    "2": "CASUAL WORK",
    "3": "CONTRACTUAL WORK",
    "4": "INDIVIDUALLY OWNED BUSINESS",
    "5": "SHARED / PARTNERSHIP BUSINESS",
    "6": "CORPORATE BUSINESS",
    "99": "N/A",
  },
  q18_place_of_work: {
    "99": "N/A",
  },
  q19_place_of_delivery: {
    "1": "PUBLIC HOSPITAL",
    "2": "PRIVATE HOSPITAL",
    "3": "CLINIC",
    "4": "HOME",
    "5": "OTHERS",
    "99": "N/A",
  },
  q20_birth_attendant: {
    "1": "DOCTOR",
    "2": "NURSE",
    "3": "MIDWIFE",
    "4": "HILOT",
    "5": "OTHERS",
    "99": "N/A",
  },
  q21_immunization: {
    "1": "BCG",
    "2": "DPT",
    "3": "OPV",
    "4": "IPV",
    "5": "OPV / IPV",
    "6": "PCV",
    "7": "RV",
    "8": "INFLUENZA",
    "9": "MEASLES",
    "10": "JE",
    "99": "N/A",
  },
  q23_family_planning_use: {
    "1": "FEMALE STERILIZATION / LIGATION",
    "2": "MALE STERILIZATION / VASECTOMY",
    "3": "IUD",
    "4": "INJECTABLES",
    "5": "IMPLANTS",
    "6": "PILL",
    "7": "CONDOM",
    "8": "LACTATIONAL AMENORRHEA METHOD",
    "9": "STANDARD DAYS METHOD",
    "10": "CERVICAL MUCUS METHOD",
    "11": "BASAL BODY TEMPERATURE",
    "12": "SYMPTO-THERMAL METHOD",
    "99": "N/A",
  },
  q24_fp_method_source: {
    "1": "GOVERNMENT HOSPITAL",
    "2": "RHU / HEALTH CENTER",
    "3": "BARANGAY HEALTH STATION",
    "4": "PRIVATE HOSPITAL",
    "5": "PHARMACY",
    "6": "OTHERS",
    "99": "N/A",
  },
  q25_intention_to_use_fp: {
    "1": "YES",
    "2": "NO",
    "99": "N/A",
  },
  q26_health_insurance: {
    "1": "PHILHEALTH PAYING MEMBER",
    "2": "PHILHEALTH DEPENDENT MEMBER",
    "3": "PHILHEALTH INDIGENT MEMBER",
    "4": "PHILHEALTH SPONSORED DEPENDENT",
    "5": "GSIS",
    "6": "SSS",
    "7": "PRIVATE / HMO",
  },
  q27_facility_visited: {
    "1": "GOVERNMENT HOSPITAL",
    "2": "RHU / HEALTH CENTER",
    "3": "BARANGAY HEALTH STATION",
    "4": "PRIVATE HOSPITAL",
    "5": "PRIVATE CLINIC",
    "6": "PHARMACY",
    "7": "HILOT / HERBALIST",
  },
  q28_health_facility_visit_reason: {
    "1": "SICK / INJURED",
    "2": "PRENATAL / POSTNATAL",
    "3": "DENTAL",
    "4": "IMMUNIZATION",
    "5": "MEDICAL CHECK-UP",
    "6": "MEDICAL REQUIREMENT",
    "7": "NHTS / CCT / 4PS REQUIREMENT",
  },
  q29_disability: {
    "0": "NONE",
    "1": "TOTAL BLINDNESS",
    "2": "LOW VISION",
    "3": "LEARNING DISABILITY",
    "4": "PSYCHOSOCIAL DISABILITY",
    "5": "MENTAL DISABILITY",
    "6": "VISUAL DISABILITY",
    "7": "ORTHOPEDIC DISABILITY",
    "8": "HEARING DISABILITY",
    "9": "SPEECH IMPAIRMENT",
  },
  q30_solo_parent: {
    "1": "REGISTERED SOLO PARENT",
    "2": "NON-SOLO PARENT",
    "3": "SOLO PARENT",
  },
  q31_registered_senior_citizen: {
    "1": "YES",
    "2": "NO",
  },
  q33_previous_residence_five_years: {
    "99": "SAME AS CURRENT RESIDENCE / N/A",
  },
  q34_previous_residence_six_months: {
    "99": "SAME AS CURRENT RESIDENCE / N/A",
  },
  q35_length_of_stay_barangay: {
    "99": "N/A",
  },
  q36_resident_type: {
    "1": "NON-MIGRANT",
    "2": "MIGRANT",
    "3": "TRANSIENT",
  },
  q37_date_of_transfer: {
    "99": "N/A",
  },
  q38_reason_leaving_previous_residence: {
    "01": "LACK OF EMPLOYMENT",
    "02": "BUSINESS",
    "03": "EDUCATION",
    "04": "OTHER PLACE",
    "05": "TRANSFER",
    "06": "PRESENCE OF RELATIVES AND FRIENDS",
    "07": "INHERITANCE",
    "99": "N/A",
  },
  q39_return_to_previous_residence: {
    "1": "YES",
    "2": "NO",
    "99": "N/A",
  },
  q40_reason_transferring_barangay: {
    "01": "LACK OF EMPLOYMENT",
    "02": "BUSINESS",
    "03": "EDUCATION",
    "04": "OTHER PLACE",
    "05": "TRANSFER",
    "06": "PRESENCE OF RELATIVES AND FRIENDS",
    "07": "INHERITANCE",
    "08": "TO LIVE WITH PARENTS",
    "09": "TO MARRY",
    "10": "TO LIVE WITH SPOUSE",
    "11": "OWNING / ACQUIRING LAND OR HOUSE",
    "12": "COMMUNITY / SOCIAL SECURITY",
    "13": "PEACE AND SECURITY",
    "14": "ACCESSIBILITY",
    "15": "OTHERS",
    "99": "N/A",
  },
  q41_duration_of_stay_current_barangay: {
    "1": "YES",
    "2": "NO",
    "99": "N/A",
  },
  q42_has_valid_ctc: {
    "1": "YES",
    "2": "NO",
    "99": "N/A",
  },
  q42_ctc_issued_in_barangay: {
    "1": "YES",
    "2": "NO",
    "99": "N/A",
  },
  q43_skills_development_training: {
    "00": "NONE / INSUFFICIENT SKILL",
    "01": "AGRICULTURAL / FISHERY",
    "02": "AUTOMOTIVE / LAND TRANSPORT",
    "03": "CONSTRUCTION",
    "04": "ELECTRONICS",
    "05": "PROCESSED FOOD AND BEVERAGES",
    "06": "FURNITURE AND FIXTURES",
    "07": "GARMENTS",
    "08": "GIFTS / TOYS / HOUSEWARE",
    "09": "HEALTH, SOCIAL, AND OTHER DEVELOPMENT",
    "10": "HEATING, VENTILATION, AIR CONDITIONING, AND REFRIGERATION",
    "11": "METALS AND ENGINEERING",
    "12": "COMMUNICATION",
    "13": "TOURISM",
    "14": "OTHERS",
  },
  q44_skills: {
    "00": "NONE / INSUFFICIENT SKILL",
    "01": "AGRICULTURAL / FISHERY",
    "02": "AUTOMOTIVE / LAND TRANSPORT",
    "03": "CONSTRUCTION",
    "04": "ELECTRONICS",
    "05": "PROCESSED FOOD AND BEVERAGES",
    "06": "FURNITURE AND FIXTURES",
    "07": "GARMENTS",
    "08": "BUILDING",
    "09": "DRIVING",
    "10": "COMPUTER",
    "11": "UPHOLSTERY",
    "12": "TAILORING",
    "13": "DRESSMAKING",
    "14": "PAINTER",
    "15": "COMMERCIAL COOKING",
    "16": "JANITORIAL SERVICES",
    "17": "MASSAGE THERAPIST",
    "18": "OTHERS",
  },
  q45_housing_tenure: {
    "1": "OWN OR OWNER-LIKE POSSESSION OF HOUSE AND LOT",
    "2": "OWN HOUSE, RENT LOT",
    "3": "OWN HOUSE, RENT-FREE LOT WITH CONSENT OF OWNER",
    "4": "OWN HOUSE, RENT-FREE LOT WITHOUT CONSENT OF OWNER",
    "5": "RENT HOUSE / ROOM",
    "6": "RENT-FREE HOUSE WITH CONSENT OF OWNER",
    "7": "RENT-FREE HOUSE WITHOUT CONSENT OF OWNER",
  },
  q46_lot_tenure: {
    "1": "OWN OR OWNER-LIKE POSSESSION OF LOT",
    "2": "RENT LOT",
    "3": "RENT-FREE LOT WITH CONSENT OF OWNER",
    "4": "RENT-FREE LOT WITHOUT CONSENT OF OWNER",
  },
  q47_lighting_fuel: {
    "0": "NONE",
    "1": "OIL",
    "2": "LIQUEFIED PETROLEUM GAS (LPG)",
    "3": "KEROSENE",
    "4": "ELECTRICITY",
    "5": "OTHERS",
  },
  q48_cooking_fuel: {
    "0": "NONE",
    "1": "WOOD",
    "2": "CHARCOAL",
    "3": "LIQUEFIED PETROLEUM GAS (LPG)",
    "4": "KEROSENE",
    "5": "ELECTRICITY",
    "6": "OTHERS",
  },
  q49_drinking_water_source: {
    "1": "PIPED INTO DWELLING",
    "2": "PIPED TO YARD / LOT",
    "3": "PIPED TO NEIGHBOR",
    "4": "PUBLIC TAP / STANDPIPE",
    "5": "TUBE WELL OR BOREHOLE",
    "6": "PROTECTED WELL",
    "7": "UNPROTECTED WELL",
    "8": "PROTECTED SPRING",
    "9": "UNPROTECTED SPRING",
    "10": "RAINWATER",
    "11": "TANKER TRUCK",
    "12": "WELL WITH SMALL TANK",
    "13": "SURFACE WATER",
    "14": "BOTTLED / SACHET WATER",
    "15": "WATER REFILLING STATION",
    "16": "OTHERS",
  },
  q50a_garbage_disposal: {
    "1": "FEEDING TO ANIMALS",
    "2": "BURNING",
    "3": "COMPOSTING",
    "4": "BURYING",
    "5": "DUMPING IN INDIVIDUAL PIT",
    "6": "DUMPING UNBURNED",
    "7": "PICKED-UP BY GARBAGE TRUCK",
  },
  q50b_segregates_garbage: {
    "1": "YES",
    "2": "NO",
  },
  q51_toilet_facility: {
    "1A": "FLUSH / POUR FLUSH TO PIPED SEWER SYSTEM",
    "1B": "FLUSH / POUR FLUSH TO SEPTIC TANK",
    "1C": "FLUSH / POUR FLUSH TO PIT LATRINE",
    "1D": "FLUSH / POUR FLUSH TO OPEN DRAIN",
    "1E": "FLUSH / POUR FLUSH TO UNKNOWN PLACE",
    "2A": "VENTILATED IMPROVED PIT LATRINE",
    "2B": "PIT LATRINE WITH SLAB",
    "2C": "PIT LATRINE WITHOUT SLAB / OPEN PIT",
    "3": "HANGING TOILET / HANGING LATRINE",
    "4": "BUCKET TOILET",
    "5": "BUCKET / PAIL SYSTEM",
    "6": "NO FACILITY / BUSH / FIELD",
    "7": "PUBLIC TOILET",
    "8": "OTHERS",
  },
  q52_building_type: {
    "1": "SINGLE HOUSE",
    "2": "DUPLEX",
    "3": "APARTMENT / ROWHOUSE",
    "4": "CONDOMINIUM / CONDO-TEL",
    "5": "COMMERCIAL / INDUSTRIAL / AGRICULTURAL BUILDING",
    "6": "INSTITUTIONAL LIVING QUARTER",
    "7": "OTHER HOUSING UNIT",
    "8": "OTHERS",
  },
  q53_wall_material: {
    "1": "CONCRETE / BRICK / STONE",
    "2": "WOOD",
    "3": "HALF CONCRETE / BRICK / STONE AND HALF WOOD",
    "4": "GALVANIZED IRON / ALUMINUM",
    "5": "BAMBOO / SAWALI / COGON / NIPA",
    "6": "ASBESTOS",
    "7": "GLASS",
    "8": "MAKESHIFT / SALVAGED / IMPROVISED MATERIALS",
    "9": "OTHERS",
    "10": "NO WALLS",
  },
  q54_female_death_past_12_months: {
    "1": "YES",
    "2": "NO",
  },
  q55_child_death_past_12_months: {
    "1": "YES",
    "2": "NO",
  },
  q55_child_death_sex: {
    "1": "MALE",
    "2": "FEMALE",
  },
} as const;

export const RBIM_CODE_META: Record<RbimCodeQuestionKey, RbimCodeMeta> = {
  q02_relationship_to_head: { label: "Q02 Relationship to Household Head" },
  q03_sex: { label: "Q03 Sex" },
  q07_nationality: { label: "Q07 Nationality" },
  q08_marital_status: { label: "Q08 Marital Status" },
  q11_highest_education: { label: "Q11 Highest Level of Education" },
  q12_currently_enrolled: { label: "Q12 Currently Enrolled" },
  q13_school_level: { label: "Q13 School Level" },
  q14_place_of_school: { label: "Q14 Place of School", allowUnmapped: true },
  q15_reason_not_attending_school: { label: "Q15 Reason for Not Attending School" },
  q17_source_of_income: { label: "Q17 Source of Income" },
  q18_work_status: { label: "Q18 Status of Work / Business" },
  q19_place_of_work: { label: "Q19 Place of Work / Business", allowUnmapped: true },
  q20_place_of_delivery: { label: "Q20 Place of Delivery" },
  q21_birth_attendant: { label: "Q21 Birth Attendant" },
  q22_immunization: { label: "Q22 Immunization", allowUnmapped: true },
  q24_family_planning_use: { label: "Q24 Family Planning Use" },
  q25_fp_method_source: { label: "Q25 Source of FP Method" },
  q26_intention_to_use_fp: { label: "Q26 Intention to Use FP" },
  q26_intended_fp_method: { label: "Q26 Intended FP Method" },
  q27_health_insurance: { label: "Q27 Health Insurance" },
  q28_facility_visited: { label: "Q28 Facility Visited" },
  q29_health_facility_visit_reason: { label: "Q29 Reason for Health Facility Visit" },
  q30_disability: { label: "Q30 Disability" },
  q31_solo_parent: { label: "Q31 Solo Parent" },
  q32_registered_senior_citizen: { label: "Q32 Registered Senior Citizen" },
  q34_length_of_stay_barangay: { label: "Q34 Length of Stay in Barangay", allowUnmapped: true },
  q35_previous_residence_five_years: { label: "Q35 Previous Residence Five Years Ago", allowUnmapped: true },
  q36_previous_residence_six_months: { label: "Q36 Previous Residence Six Months Ago", allowUnmapped: true },
  q37_resident_type: { label: "Q37 Type of Resident" },
  q38_date_of_transfer: { label: "Q38 Date of Transfer", allowUnmapped: true },
  q39_reason_leaving_previous_residence: { label: "Q39 Reason for Leaving Previous Residence" },
  q40_return_to_previous_residence: { label: "Q40 Return to Previous Residence" },
  q41_reason_transferring_barangay: { label: "Q41 Reason for Transferring to Barangay" },
  q42_duration_of_stay_current_barangay: { label: "Q42 Duration of Stay in Current Barangay" },
  q43a_has_valid_ctc: { label: "Q43A Has Valid CTC" },
  q43b_ctc_issued_in_barangay: { label: "Q43B CTC Issued in Barangay", allowUnmapped: true },
  q44_skills_development_training: { label: "Q44 Skills Development Training", allowUnmapped: true },
  q45_skills: { label: "Q45 Skills" },
  q46_housing_unit_tenure: { label: "Q46 Housing Unit Tenure" },
  q47_lot_tenure: { label: "Q47 Lot Tenure" },
  q48_hazard_prone_area: { label: "Q48 Hazard-Prone Area" },
  q49_disaster_experienced_past_5_years: { label: "Q49 Disaster Experienced in the Past 5 Years" },
  q50_knows_nearest_evacuation_center: { label: "Q50 Knows Nearest Evacuation Center" },
  q51_fuel_lighting: { label: "Q51 Fuel for Lighting" },
  q52_fuel_cooking: { label: "Q52 Fuel for Cooking" },
  q53_drinking_water_source: { label: "Q53 Main Source of Drinking Water" },
  q54a_kitchen_garbage_disposal: { label: "Q54a Kitchen Garbage Disposal" },
  q54b_garbage_segregation: { label: "Q54b Garbage Segregation" },
  q55_toilet_facility_final: { label: "Q55 Toilet Facility" },
  q56_building_type: { label: "Q56 Type of Building / House" },
  q57_wall_material: { label: "Q57 Construction Materials of Outer Wall" },
  q58_female_death_past_12_months: { label: "Q58 Female Member Died in Past 12 Months" },
  q59_child_death_past_12_months: { label: "Q59 Child Below 5 Died in Past 12 Months" },
  q59_child_death_sex: { label: "Q59 Child Death Sex" },
  // Legacy questionnaire metadata retained for historical import/code normalization.
  q16_source_of_income: { label: "Q16 Source of Income" },
  q17_work_status: { label: "Q17 Status of Work / Business" },
  q18_place_of_work: { label: "Q18 Place of Work / Business", allowUnmapped: true },
  q19_place_of_delivery: { label: "Q19 Place of Delivery" },
  q20_birth_attendant: { label: "Q20 Birth Attendant" },
  q21_immunization: { label: "Q21 Immunization" },
  q23_family_planning_use: { label: "Q23 Family Planning Use" },
  q24_fp_method_source: { label: "Q24 Source of FP Method" },
  q25_intention_to_use_fp: { label: "Q25 Intention to Use FP", allowUnmapped: true },
  q26_health_insurance: { label: "Q26 Health Insurance", allowUnmapped: true },
  q27_facility_visited: { label: "Q27 Facility Visited", allowUnmapped: true },
  q28_health_facility_visit_reason: { label: "Q28 Reason for Health Facility Visit", allowUnmapped: true },
  q29_disability: { label: "Q29 Disability" },
  q30_solo_parent: { label: "Q30 Solo Parent" },
  q31_registered_senior_citizen: { label: "Q31 Registered Senior Citizen" },
  q33_previous_residence_five_years: { label: "Q33 Previous Residence", allowUnmapped: true },
  q34_previous_residence_six_months: { label: "Legacy Q34 Previous Residence", allowUnmapped: true },
  q35_length_of_stay_barangay: { label: "Legacy Q35 Length of Stay in Barangay", allowUnmapped: true },
  q36_resident_type: { label: "Legacy Q36 Type Resident" },
  q37_date_of_transfer: { label: "Q37 Date of Transfer", allowUnmapped: true },
  q38_reason_leaving_previous_residence: { label: "Q38 Reason for Leaving Previous Residence" },
  q39_return_to_previous_residence: { label: "Q40 Return to Previous Residence", allowUnmapped: true },
  q40_reason_transferring_barangay: { label: "Q41 Reason for Transferring in this Barangay" },
  q41_duration_of_stay_current_barangay: { label: "Q41 Duration of Stay in Current Barangay", allowUnmapped: true },
  q42_has_valid_ctc: { label: "Q42A Has Valid CTC" },
  q42_ctc_issued_in_barangay: { label: "Q42B CTC Issued in Barangay" },
  q43_skills_development_training: { label: "Q43 Skills Development Training" },
  q44_skills: { label: "Q44 Skills", allowUnmapped: true },
  q45_housing_tenure: { label: "Q45 Housing Tenure" },
  q46_lot_tenure: { label: "Q46 Lot Tenure" },
  q47_lighting_fuel: { label: "Q47 Fuel for Lighting" },
  q48_cooking_fuel: { label: "Q48 Fuel for Cooking" },
  q49_drinking_water_source: { label: "Q49 Drinking Water Source" },
  q50a_garbage_disposal: { label: "Q50a Garbage Disposal" },
  q50b_segregates_garbage: { label: "Q50b Garbage Segregation" },
  q51_toilet_facility: { label: "Q51 Toilet Facility" },
  q52_building_type: { label: "Q52 Type of Building / House" },
  q53_wall_material: { label: "Q53 Outer Wall Material" },
  q54_female_death_past_12_months: { label: "Q54 Female Death in Past 12 Months" },
  q55_child_death_past_12_months: { label: "Q55 Child Death in Past 12 Months" },
  q55_child_death_sex: { label: "Q55 Child Death Sex" },
};

const RBIM_LABEL_ALIASES: Partial<Record<RbimCodeQuestionKey, Record<string, string>>> = {
  q02_relationship_to_head: {
    "HOUSEHOLD HEAD": "01",
    HHH: "01",
    STEPSON: "05",
    STEPDAUGHTER: "06",
    "STEPSON STEPDAUGHTER": "19",
    "SON IN LAW": "07",
    "DAUGHTER IN LAW": "08",
    GRANDCHILD: "19",
    "BROTHER SISTER": "19",
    "FATHER MOTHER": "19",
    NONRELATIVE: "20",
    OTHER: "19",
  },
  q08_marital_status: {
    "COMMON LAW": "3",
    "COMMON LAW LIVE IN": "3",
    "LIVE IN": "3",
    "LIVING IN": "3",
    LIVINGIN: "3",
  },
  q11_highest_education: {
    NONE: "0",
    "NO EDUCATION": "0",
    "NO GRADE COMPLETED": "0",
    PRESCHOOL: "1",
    "PRE SCHOOL": "1",
    "PRE SCHOOL EDUCATION": "1",
    "EARLY CHILDHOOD": "1",
    "ELEMENTARY": "2",
    "ELEMENTARY EDUCATION": "2",
    "JUNIOR HIGH SCHOOL": "3",
    "JUNIOR HS": "3",
    "SENIOR HIGH SCHOOL": "4",
    "SENIOR HS": "4",
    "POST SECONDARY NON TERTIARY": "5",
    VOCATIONAL: "5",
    "VOCATIONAL TECHNICAL": "5",
    "SHORT CYCLE TERTIARY": "6",
    COLLEGE: "7",
    "COLLEGE LEVEL": "7",
    "COLLEGE GRADUATE": "7",
    BACHELOR: "7",
    MASTERS: "8",
    MASTER: "8",
    DOCTORAL: "9",
    DOCTORATE: "9",
  },
  q12_currently_enrolled: {
    YES: "1",
    PUBLIC: "1",
    "YES PUBLIC": "1",
    PRIVATE: "2",
    "YES PRIVATE": "2",
  },
  q13_school_level: {
    PRESCHOOL: "0",
    "PRE SCHOOL": "0",
    "EARLY CHILDHOOD": "0",
    ELEMENTARY: "1",
    "JUNIOR HS": "2",
    "JUNIOR HIGH SCHOOL": "2",
    "SENIOR HS": "3",
    "SENIOR HIGH SCHOOL": "3",
    VOCATIONAL: "4",
    COLLEGE: "6",
    UNIVERSITY: "6",
    BACHELOR: "6",
    MASTER: "7",
    DOCTORAL: "8",
  },
  q18_work_status: {
    "SHARED PARTNERSHIP BUSINESS": "5",
    "SHARED PARTNERSHIP": "5",
    "PARTNERSHIP BUSINESS": "5",
  },
  q20_place_of_delivery: {
    "LYING IN CLINIC": "3",
    LYINGIN: "3",
  },
  q22_immunization: {
    OPVIPV: "5",
    "OPV IPV": "5",
    JE: "10",
  },
  q24_family_planning_use: {
    LIGATION: "1",
    "FEMALE STERILIZATION": "1",
    VASECTOMY: "2",
    "MALE STERILIZATION": "2",
    LAM: "9",
    "LACTATIONAL AMENORRHEA METHOD": "9",
  },
  q25_fp_method_source: {
    RHU: "2",
    "HEALTH CENTER": "2",
    "RHU HEALTH CENTER": "2",
    BHS: "3",
  },
  q26_intended_fp_method: {
    LIGATION: "1",
    "FEMALE STERILIZATION": "1",
    VASECTOMY: "2",
    "MALE STERILIZATION": "2",
    LAM: "9",
    "LACTATIONAL AMENORRHEA METHOD": "9",
    TRADITIONAL: "10",
  },
};

const RBIM_CODE_OPTION_ORDER: Partial<Record<RbimCodeQuestionKey, readonly string[]>> = {
  q02_relationship_to_head: [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
  ],
  q39_reason_leaving_previous_residence: [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "99",
  ],
};

export function normalizeRBIMCode(value: string | number | null | undefined) {
  return String(value ?? "").trim().toUpperCase();
}

export function cleanRBIMCode(
  questionKey: RbimCodeQuestionKey,
  encodedValue: string | number | null | undefined,
): RbimCodeCleanResult {
  const rawValue = String(encodedValue ?? "").trim().replace(/\s+/g, " ");
  const code = normalizeRBIMCode(rawValue);

  if (!code) {
    return { code, label: null };
  }

  const nonFilipinoNationality = parseNonFilipinoNationality(questionKey, rawValue);

  if (nonFilipinoNationality) {
    return nonFilipinoNationality;
  }

  const map = RBIM_CODE_MAP[questionKey] as Record<string, string>;
  const multiCode = parseMultiCodeAnswer(questionKey, rawValue, map);

  if (multiCode) {
    return multiCode;
  }

  const otherSpecify = parseOtherSpecify(questionKey, rawValue, map);

  if (otherSpecify) {
    return otherSpecify;
  }

  const codeWithDetail = parseCodeWithDetail(questionKey, rawValue, map);

  if (codeWithDetail) {
    return codeWithDetail;
  }

  const directCode = findCodeInMap(map, rawValue);

  if (directCode) {
    return { code: directCode, label: map[directCode] };
  }

  const displayCode = extractDisplayCode(rawValue);

  if (displayCode) {
    const displayMatch = findCodeInMap(map, displayCode);

    if (displayMatch) {
      return { code: displayMatch, label: map[displayMatch] };
    }
  }

  const normalizedLabel = normalizeLabelForMatch(rawValue);
  const labelWithCodeMatch = parseLabelWithCode(rawValue, map);

  if (labelWithCodeMatch) {
    return labelWithCodeMatch;
  }

  const specialLabelCode = getSpecialLabelCode(normalizedLabel);

  if (specialLabelCode && map[specialLabelCode]) {
    return { code: specialLabelCode, label: map[specialLabelCode] };
  }

  const aliasCode = RBIM_LABEL_ALIASES[questionKey]?.[normalizedLabel];

  if (aliasCode && map[aliasCode]) {
    return { code: aliasCode, label: map[aliasCode] };
  }

  const labelMatch = Object.entries(map).find(([, label]) => normalizeLabelForMatch(label) === normalizedLabel);

  if (labelMatch) {
    return { code: labelMatch[0], label: labelMatch[1] };
  }

  const othersLabelMatch = parseOthersLabel(rawValue, map);

  if (othersLabelMatch) {
    return othersLabelMatch;
  }

  if (RBIM_CODE_META[questionKey].allowUnmapped) {
    return { code: rawValue, label: rawValue };
  }

  return {
    code: rawValue,
    label: null,
    error: `Invalid code for ${RBIM_CODE_META[questionKey].label}.`,
  };
}

export function rbimCodeLabel(questionKey: RbimCodeQuestionKey, encodedValue: string | number | null | undefined) {
  return cleanRBIMCode(questionKey, encodedValue).label;
}

export function rbimCodeOrLabelToCode(
  questionKey: RbimCodeQuestionKey,
  value: string | number | null | undefined,
) {
  const cleaned = cleanRBIMCode(questionKey, value);

  if (!cleaned.code) {
    return "";
  }

  return cleaned.error ? cleaned.code : cleaned.code;
}

export function rbimCodeOrLabelToLabel(
  questionKey: RbimCodeQuestionKey,
  value: string | number | null | undefined,
) {
  const cleaned = cleanRBIMCode(questionKey, value);
  return cleaned.error ? cleaned.code : (cleaned.label ?? "");
}

export function getRBIMCodeOptions(questionKey: RbimCodeQuestionKey): RbimCodeOption[] {
  const map = RBIM_CODE_MAP[questionKey] as Record<string, string>;
  const orderedCodes = RBIM_CODE_OPTION_ORDER[questionKey];

  const options = orderedCodes
    ? orderedCodes
        .filter((code) => map[code])
        .map((code) => ({
          code,
          label: map[code],
          displayValue: `${code} - ${map[code]}`,
        }))
    : Object.entries(map).map(([code, label]) => ({
        code,
        label,
        displayValue: `${code} - ${label}`,
      }));

  /*
   * RBIM coded questionnaire choices that use numeric codes must appear
   * in true numeric order regardless of the source declaration order.
   *
   * Examples:
   *   01, 02, 03, ... 15, 99
   *   01, 02, 03, ... 18, 99
   *   0, 1, 2, ... 99
   *
   * Code 99 (N/A) is always placed last.
   *
   * If a question uses non-numeric codes, preserve its established
   * source order instead of imposing numeric sorting on it.
   */
  const allCodesAreNumeric = options.every((option) => /^\d+$/.test(option.code));

  if (!allCodesAreNumeric) {
    const regularOptions = options.filter((option) => option.code !== "99");
    const notApplicableOptions = options.filter((option) => option.code === "99");

    return [...regularOptions, ...notApplicableOptions];
  }

  return [...options].sort((a, b) => {
    const aNumber = Number(a.code);
    const bNumber = Number(b.code);

    if (aNumber === 99 && bNumber !== 99) {
      return 1;
    }

    if (bNumber === 99 && aNumber !== 99) {
      return -1;
    }

    return aNumber - bNumber;
  });
}

export function isRBIMNotApplicable(value: string | number | null | undefined) {
  const normalizedLabel = normalizeLabelForMatch(value);
  return normalizedLabel === "NOT APPLICABLE" || normalizedLabel === "N A" || normalizeRBIMCode(value).startsWith("99");
}

function extractDisplayCode(value: string) {
  return /^([A-Z0-9]+)\s*[-:]\s*.+$/i.exec(value)?.[1] ?? "";
}

function parseLabelWithCode(value: string, map: Record<string, string>): RbimCodeCleanResult | null {
  const match = /^(.+?)\s*[-:]\s*([A-Z0-9]+)$/i.exec(value.trim());

  if (!match) {
    return null;
  }

  const code = findCodeInMap(map, match[2]);

  if (!code) {
    return null;
  }

  const normalizedTypedLabel = normalizeLabelForMatch(match[1]);
  const normalizedMappedLabel = normalizeLabelForMatch(map[code]);

  if (
    normalizedTypedLabel === normalizedMappedLabel ||
    normalizedMappedLabel.startsWith(normalizedTypedLabel) ||
    normalizedTypedLabel.startsWith(normalizedMappedLabel)
  ) {
    return { code, label: map[code] };
  }

  return null;
}

function findCodeInMap(map: Record<string, string>, value: string) {
  const normalizedCode = normalizeRBIMCode(value);

  if (map[normalizedCode]) {
    return normalizedCode;
  }

  if (/^\d+$/.test(normalizedCode)) {
    const unpaddedCode = String(Number(normalizedCode));

    if (map[unpaddedCode]) {
      return unpaddedCode;
    }

    const numericMatch = Object.keys(map).find((code) => /^\d+$/.test(code) && Number(code) === Number(normalizedCode));

    if (numericMatch) {
      return numericMatch;
    }
  }

  return "";
}

function parseMultiCodeAnswer(
  questionKey: RbimCodeQuestionKey,
  value: string,
  map: Record<string, string>,
): RbimCodeCleanResult | null {
  if (questionKey !== "q22_immunization" || !/[,;/]/.test(value)) {
    return null;
  }

  const rawCodes = value
    .split(/[,;/]+/)
    .map((part) => part.trim())
    .filter(Boolean);

  if (rawCodes.length <= 1) {
    return null;
  }

  if (!rawCodes.every((rawCode) => /^\d+$/.test(rawCode))) {
    return null;
  }

  const codes = rawCodes.map((rawCode) => findCodeInMap(map, rawCode));
  const invalidCode = rawCodes.find((_, index) => !codes[index]);

  if (invalidCode) {
    return {
      code: value,
      label: null,
      error: `Invalid code for ${RBIM_CODE_META[questionKey].label}.`,
    };
  }

  const uniqueCodes = Array.from(new Set(codes));

  return {
    code: uniqueCodes.join(","),
    label: uniqueCodes.map((code) => map[code]).join(", "),
  };
}

function getSpecialLabelCode(normalizedLabel: string) {
  if (normalizedLabel === "NOT APPLICABLE" || normalizedLabel === "N A" || normalizedLabel === "NA") {
    return "99";
  }

  return "";
}

function normalizeLabelForMatch(value: string | number | null | undefined) {
  return String(value ?? "")
    .trim()
    .toUpperCase()
    .replace(/&/g, " AND ")
    .replace(/['’]/g, "")
    .replace(/[^A-Z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function parseNonFilipinoNationality(
  questionKey: RbimCodeQuestionKey,
  value: string,
): RbimCodeCleanResult | null {
  if (questionKey !== "q07_nationality") {
    return null;
  }

  const match = /^0*2(?:\s*[-,:]\s*|\s+)(.+)$/i.exec(value);

  if (!match) {
    return null;
  }

  const nationality = match[1].trim();

  if (!nationality) {
    return null;
  }

  return {
    code: "2",
    label: `Non-Filipino, ${toReadableNationality(nationality)}`,
  };
}

function parseOtherSpecify(
  questionKey: RbimCodeQuestionKey,
  value: string,
  map: Record<string, string>,
): RbimCodeCleanResult | null {
  if (questionKey === "q07_nationality") {
    return null;
  }

  const match = /^([A-Z0-9]+)(?:\s*[-,:]\s*|\s+)(.+)$/i.exec(value.trim());

  if (!match) {
    return null;
  }

  const code = findCodeInMap(map, match[1]);
  const specifiedValue = match[2].trim();

  if (!code || !specifiedValue || !normalizeLabelForMatch(map[code]).startsWith("OTHERS")) {
    return null;
  }

  return {
    code,
    label: `Others, ${toReadableNationality(specifiedValue)}`,
  };
}

const DETAIL_CODE_QUESTIONS = new Set<RbimCodeQuestionKey>([
  "q26_intention_to_use_fp",
  "q40_return_to_previous_residence",
  "q42_duration_of_stay_current_barangay",
]);

function parseCodeWithDetail(
  questionKey: RbimCodeQuestionKey,
  value: string,
  map: Record<string, string>,
): RbimCodeCleanResult | null {
  if (!DETAIL_CODE_QUESTIONS.has(questionKey)) {
    return null;
  }

  const match = /^([A-Z0-9]+)(?:\s*[-,:]\s*|\s+)(.+)$/i.exec(value.trim());

  if (!match) {
    return null;
  }

  const code = findCodeInMap(map, match[1]);
  const specifiedValue = match[2].trim();

  if (!code || !specifiedValue) {
    return null;
  }

  if (normalizeLabelForMatch(specifiedValue) === normalizeLabelForMatch(map[code])) {
    return { code, label: map[code] };
  }

  return {
    code,
    label: `${map[code]}, ${toReadableNationality(specifiedValue)}`,
  };
}

function parseOthersLabel(value: string, map: Record<string, string>): RbimCodeCleanResult | null {
  const othersEntry = Object.entries(map).find(([, label]) => normalizeLabelForMatch(label) === "OTHERS");

  if (!othersEntry) {
    return null;
  }

  const normalizedValue = normalizeLabelForMatch(value);

  if (normalizedValue === "OTHERS" || normalizedValue === "OTHERS SPECIFY" || normalizedValue === "OTHERS PLEASE SPECIFY") {
    return { code: othersEntry[0], label: othersEntry[1] };
  }

  const match = /^others(?:\s*[-,:]\s*|\s+)(.+)$/i.exec(value.trim());
  const specifiedValue = match?.[1]?.trim();

  if (!specifiedValue || /^please\s+specify$/i.test(specifiedValue) || /^specify$/i.test(specifiedValue)) {
    return null;
  }

  return {
    code: othersEntry[0],
    label: `Others, ${toReadableNationality(specifiedValue)}`,
  };
}

function toReadableNationality(value: string) {
  return value
    .toLowerCase()
    .replace(/[a-z]+(?:['-][a-z]+)*/g, (word) =>
      word
        .split("-")
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join("-"),
    );
}
